export function enableZoom(context) {
  setTimeout(() => {
    const store = context._ctx && context._ctx.store;
    const map = context.map && context.map;

    if (!map && !store.getInitialValue) {
      return;
    }

    if (!store.getInitialConfigValue('doubleClickZoom')) {
      return;
    }

    map.doubleClickZoom.enable();
  }, 0);
}

export function disableZoom(context) {
  setTimeout(() => {
    const { map } = context;
    const doubleClickZoom = map && map.doubleClickZoom;

    if (!map || !doubleClickZoom) {
      return;
    }
    
    doubleClickZoom.disable();
  }, 0);
}